















import { EmitToCarouselMixin } from '@/components/mixins/emit-to-carousel';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component
export default class Pagination extends Mixins(EmitToCarouselMixin) {
  @Prop({ required: true })
  slidesLength!: number;

  @Prop({ required: true })
  activeSlideIndex!: number;
}
